module.exports = __webpack_public_path__ + "static/media/jsx_logo.bc273407.jpg";